import create from "zustand";


export default create((set) => {
    return {
        vueMode: 'house',
        setVueMode: (mode) => {
            set(() => {
                return { vueMode: mode }
            })
        }
    }
})

